import {getFetchedJSON, fetchWithStateSpecial} from '~/misc/fetch';

export const getMsgFromAccount = (getState) => fetchWithStateSpecial(getState, {
  method: 'POST',
  url: '/tl/currentUserInfo',
  headerMsg: {email: true},
}).then(getFetchedJSON);



// WEBPACK FOOTER //
// ./src/modules/account/api.js